import React, { ChangeEvent, useRef } from 'react'
import { Text } from '@hip/components/src/components/text/text'
import classNames from 'classnames'
import { Button } from '@hip/components/src/components/button/button'
import { _t } from '@hip/translations'

import { Modal } from '../modal/modal'
import { abMobileCTA } from '../../../utils/ABMobileCTA'

import styles from './book-appointment-modal.module.css'

interface BookAppointmentModalProps {
  show: boolean
  designId: string
  close: () => void
  handleAppointmentClick: () => void
}

export const BookAppointmentModal: React.FC<BookAppointmentModalProps> = props => {
  const { show, designId, close, handleAppointmentClick } = props

  const [enableCheckbox, setEnableCheckbox] = React.useState(false)

  const checkboxRef = useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    return () => {
      onClose()
    }
  }, [])

  const handleCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    setEnableCheckbox(event.target.checked)
    event.stopPropagation()
  }

  const onClose = () => {
    if (checkboxRef.current?.checked) {
      abMobileCTA.setIgnoreCTAForDesign(designId)
      checkboxRef.current.checked = false
      setEnableCheckbox(false)
    }
    close()
  }

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={_t('book-appointment-mobile-modal.title')}
      verticalAlignCenter={true}
      customizations={{
        iconSize: 's',
        titleEl: 'h4',
      }}
    >
      <div className={classNames(styles.BookAppointmentModalContent)}>
        <label
          htmlFor="do-not-show-again"
          className={classNames(styles.BookAppointmentModalActionRow)}
        >
          <input
            ref={checkboxRef}
            id={'do-not-show-again'}
            className={classNames(styles.CTACheckbox)}
            type={'checkbox'}
            checked={enableCheckbox}
            onChange={handleCheckbox}
          />
          <Text>{_t('book-appointment-mobile-modal.checkbox-title')}</Text>
        </label>
        <Button type="primary" onClick={handleAppointmentClick}>
          <Text color="white" vMargin="none">
            {_t('book-appointment-mobile-modal.primary-action-text')}
          </Text>
        </Button>
      </div>
    </Modal>
  )
}
